import { render, staticRenderFns } from "./assistantChatView.vue?vue&type=template&id=82937044&scoped=true"
import script from "./assistantChatView.vue?vue&type=script&lang=js"
export * from "./assistantChatView.vue?vue&type=script&lang=js"
import style0 from "./assistantChatView.vue?vue&type=style&index=0&id=82937044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82937044",
  null
  
)

export default component.exports